const ossSupportedImageFormat =
  /\.(?:jpg|jpeg|png|bmp|gif|webp|tif|tiff|heic)$/;

/**
 * 阿里云 OSS 相关的域名
 */
const ALIYUN_OSS_DOMAINS: string[] = ['aliyuncs.com'];

function isPostProcessable(src: string | URL) {
  try {
    const url = typeof src === 'string' ? new URL(src) : src;

    const isAliyunOssDomains = ALIYUN_OSS_DOMAINS.some((oss) =>
      url.hostname.endsWith(oss),
    );

    if (!isAliyunOssDomains) {
      return false;
    }

    return ossSupportedImageFormat.test(url.pathname);
  } catch {
    return false;
  }
}

/**
 * 处理 OSS 上的图片
 * @param src 图片源地址
 * @param size 尺寸
 * @param mode 缩放模式
 * @returns
 */
export function processOssImage(
  src: string | undefined,
  size: number | undefined,
  mode?: 'lfit' | 'mfit' | 'fill' | 'pad' | 'fixed',
): string | undefined {
  if (!src || !size) {
    return;
  }

  if (!URL.canParse(src)) {
    return;
  }

  const url = new URL(src);

  if (!isPostProcessable(url)) {
    return;
  }

  url.searchParams.set(
    'x-oss-process',
    `image/resize,w_${size},h_${size},m_${mode ?? 'lfit'}`,
  );

  return url.toString();
}
